import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { DashBoardComponent } from './components/dash-board/dash-board.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { LoginPageComponent } from './login-page/login-page.component';
import { TokenInterceptor } from './services/token.interceptor';
import { UsersListComponent } from './components/user-management/users-list/users-list.component';
import { CreateUserComponent } from './components/user-management/create-user/create-user.component';
import { ProductMasterManagementComponent } from './components/inventery-management/product-master-management/product-master-management.component';
import { BranchMasterManagementComponent } from './components/inventery-management/branch-master-management/branch-master-management.component';
import { VendorMasterManagementComponent } from './components/inventery-management/vendor-master-management/vendor-master-management.component';
import { TaskListComponent } from './components/task-management/task-list/task-list.component';
import { AddTaskComponent } from './components/task-management/add-task/add-task.component';
import { TaskCommComponent } from './components/task-management/task-comm/task-comm.component';
import { ModifyTaskComponent } from './components/task-management/modify-task/modify-task.component';
import { DeleteTaskComponent } from './components/task-management/delete-task/delete-task.component';
import { TicketsListComponent } from './components/ticket-management/tickets-list/tickets-list.component';
import { AddTicketComponent } from './components/ticket-management/add-ticket/add-ticket.component';
import { TicketCommComponent } from './components/ticket-management/ticket-comm/ticket-comm.component';
import { ModifyTicketComponent } from './components/ticket-management/modify-ticket/modify-ticket.component';
import { DeleteTicketComponent } from './components/ticket-management/delete-ticket/delete-ticket.component';
import { AuthGuard } from './guards/auth.guard';
import { MaterialIssuesComponent } from './components/inventery-management/material-issues/material-issues.component';
import { MaterialTransferComponent } from './components/inventery-management/material-transfer/material-transfer.component';
import { MaterialPurchaseComponent } from './components/inventery-management/material-purchase/material-purchase.component';
import { MaterialIssueRequestsComponent } from './components/inventery-management/material-issue-requests/material-issue-requests.component';
import { ProductStockManagementComponent } from './components/product-stock-management/product-stock-management.component';
import { NotificationManagementComponent } from './components/notification-management/notification-management.component';
import { DefineParamsComponent } from './components/define-params/define-params.component';
import { ChangePasswordComponent } from './components/user-management/change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ObjectTemplateComponent } from './components/object-template/object-template.component';
import { ProductOpeningBalanceComponent } from './components/inventery-management/product-opening-balance/product-opening-balance.component';
import { RolesComponent } from './components/user-management/roles/roles.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TaskFilterComponent } from './components/task-management/task-filter/task-filter.component';
import { PrivilegesListComponent } from './components/privileges-controller/privileges-list/privileges-list.component';
import { MyTasksComponent } from './components/task-management/my-tasks/my-tasks.component';
import { TicketFilterComponent } from './components/ticket-management/ticket-filter/ticket-filter.component';
import { WebsocketService } from './services/websocket.service';
import { ChatService } from './services/chat.service';
import { TaskPostedByMeComponent } from './components/task-management/task-posted-by-me/task-posted-by-me.component';
import { TicketPostedByMeComponent } from './components/ticket-management/ticket-posted-by-me/ticket-posted-by-me.component';
import { DeleteProductComponent } from './components/inventery-management/delete-product/delete-product.component';
import { DeleteVendorComponent } from './components/inventery-management/delete-vendor/delete-vendor.component';
import { DeleteBranchComponent } from './components/inventery-management/delete-branch/delete-branch.component';
import { DeleteIssueComponent } from './components/inventery-management/delete-issue/delete-issue.component';
import { DeletePurchaseComponent } from './components/inventery-management/delete-purchase/delete-purchase.component';
import { DeleteTransferComponent } from './components/inventery-management/delete-transfer/delete-transfer.component';
import { DeleteUserComponent } from './components/user-management/delete-user/delete-user.component';
import { DeleteRoleComponent } from './components/user-management/delete-role/delete-role.component';
import { DeletePrivilegeComponent } from './components/privileges-controller/delete-privilege/delete-privilege.component';
import { TicketSubTypeComponent } from './components/master-data-management/ticket-sub-type/ticket-sub-type.component';
import { TicketTypesComponent } from './components/master-data-management/ticket-types/ticket-types.component';
import { TaskMasterComponent } from './components/master-data-management/task-master/task-master.component';
import { ParamsUpdateComponent } from './components/master-data-management/params-update/params-update.component';
import { ParamsListComponent } from './components/master-data-management/params-list/params-list.component';
import { CustomerParamsComponent } from './components/master-data-management/customer-params/customer-params.component';
import { DeleteTicketTypeComponent } from './components/master-data-management/delete-ticket-type/delete-ticket-type.component';
import { DeleteTicketSubTypeComponent } from './components/master-data-management/delete-ticket-sub-type/delete-ticket-sub-type.component';
import { DeleteParamComponent } from './components/master-data-management/delete-param/delete-param.component';
import { DeleteCustomerParamComponent } from './components/master-data-management/delete-customer-param/delete-customer-param.component';
import { ProdcutCompositionComponent } from './components/prodcut-composition/prodcut-composition.component';
import { UpdateProductComponent } from './components/inventery-management/update-product/update-product.component';
import { UpdateBranchComponent } from './components/inventery-management/update-branch/update-branch.component';
import { UpdateVendorComponent } from './components/inventery-management/update-vendor/update-vendor.component';
import { ModifyTicketTypeComponent } from './components/master-data-management/modify-ticket-type/modify-ticket-type.component';
import { ModifyTicketSubTypeComponent } from './components/master-data-management/modify-ticket-sub-type/modify-ticket-sub-type.component';
import { ModifyCustomerParamComponent } from './components/master-data-management/modify-customer-param/modify-customer-param.component';
import { ModifyParamComponent } from './components/master-data-management/modify-param/modify-param.component';
import { ModifyCustomerInfoComponent } from './components/modify-customer-info/modify-customer-info.component';
import { ModifyCompanyNewsComponent } from './components/modify-company-news/modify-company-news.component';
import { ModifyUserComponent } from './components/user-management/modify-user/modify-user.component';
import { ModifyRoleComponent } from './components/user-management/modify-role/modify-role.component';
import { ModifyPrivilegeComponent } from './components/privileges-controller/modify-privilege/modify-privilege.component';
import { ObjectDeleteComponent } from './components/object-delete/object-delete.component';
import { ObjectModifyComponent } from './components/object-modify/object-modify.component';
import { ProdcutModifyComponent } from './components/prodcut-modify/prodcut-modify.component';
import { ProdcutDeleteComponent } from './components/prodcut-delete/prodcut-delete.component';
import { UserTaskComponent } from './components/task-management/user-task/user-task.component';
import { UserTicketComponent } from './components/ticket-management/user-ticket/user-ticket.component';
import { PendingApprovalComponent } from './components/pending-approval/pending-approval.component';
import { RouteManagementComponent } from './components/master-data-management/route-management/route-management.component';
import { RouteModifyComponent } from './components/master-data-management/route-modify/route-modify.component';
import { RouteDeleteComponent } from './components/master-data-management/route-delete/route-delete.component';
import { RouteMapComponent } from './components/network-visibility/route-map/route-map.component';
import { LocateDeviceComponent } from './components/network-visibility/locate-device/locate-device.component';
import { OfferListComponent } from './components/offer-module/offer-list/offer-list.component';
import { OfferDeleteComponent } from './components/offer-module/offer-delete/offer-delete.component';
import { OfferModifyComponent } from './components/offer-module/offer-modify/offer-modify.component';
import { OfferAddComponent } from './components/offer-module/offer-add/offer-add.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EmployeeAttendenceComponent } from './components/employee-module/employee-attendence/employee-attendence.component';
import { TaskTrackingComponent } from './components/employee-module/task-tracking/task-tracking.component';

import { CardModule } from 'primeng/card';
import { ServiceDefinitionComponent } from './components/master-data-management/service-definition/service-definition.component';

import { UserTrackingComponent } from './components/employee-module/user-tracking/user-tracking.component';
import { TimelineModule } from "primeng/timeline";
import { AccordionModule } from 'primeng/accordion';
import { MenuItem } from 'primeng/api';
import { CustomerAPKVersionComponent } from './components/master-data-management/customer-apk-version/customer-apk-version.component';
import { DeleteCustomerAPKComponent } from './components/master-data-management/delete-customer-apk/delete-customer-apk.component';
import { ModifyCustomerAPKComponent } from './components/master-data-management/modify-customer-apk/modify-customer-apk.component';
import { DeleteServiceDefinitionComponent } from './components/master-data-management/delete-service-definition/delete-service-definition.component';
import { ModifyServiceDefinitionComponent } from './components/master-data-management/modify-service-definition/modify-service-definition.component';
import { SearchTicketsComponent } from './components/ticket-management/search-tickets/search-tickets.component';
import { MarketingDataComponent } from './components/offer-module/marketing-data/marketing-data.component';
import { StatusInfoComponent } from './components/master-data-management/status-info/status-info.component';
import { ObjectTypeGroupComponent } from './components/master-data-management/object-type-group/object-type-group.component';
import { MarketingDataFilterComponent } from './components/offer-module/marketing-data-filter/marketing-data-filter.component';
import { MarketingDataByUserComponent } from './components/offer-module/marketing-data-by-user/marketing-data-by-user.component';
import { OnlineStatusModule } from 'ngx-online-status';
import { ProfileComponent } from './components/user-management/profile/profile.component';
import { PopupComponent } from './components/network-visibility/popup/popup.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CProductListComponent } from './components/c-product/c-product-list/c-product-list.component';
import { ProductCompositionComponent } from './components/product-composition/product-composition.component';
import { ProductCompositionListComponent } from './components/product-composition-list/product-composition-list.component';
import { AddMaterialChargeComponent } from './components/material-charge/add-material-charge/add-material-charge.component';
import { MaterialChargeListComponent } from './components/material-charge/material-charge-list/material-charge-list.component';
import { ProductDisplayZoneListComponent } from './components/product-display-zone-controller/product-display-zone-list/product-display-zone-list.component';
import { AddProductDisplayZoneComponent } from './components/product-display-zone-controller/add-product-display-zone/add-product-display-zone.component';
import { ModifyProductDisplayZoneComponent } from './components/product-display-zone-controller/modify-product-display-zone/modify-product-display-zone.component';
import { DeleteProductDisplayZoneComponent } from './components/product-display-zone-controller/delete-product-display-zone/delete-product-display-zone.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ProductCategoryListComponent } from './components/product-category-controller/product-category-list/product-category-list.component';
import { AddProductCategoryComponent } from './components/product-category-controller/add-product-category/add-product-category.component';
import { ModifyProductCategoryComponent } from './components/product-category-controller/modify-product-category/modify-product-category.component';
import { DeleteProductCategoryComponent } from './components/product-category-controller/delete-product-category/delete-product-category.component';
import { ProductCompositionDeleteComponent } from './components/product-composition-delete/product-composition-delete.component';
import { ProductCompositionModifyComponent } from './components/product-composition-modify/product-composition-modify.component';
import { AddProductMasterComponent } from './components/product-master-controller/add-product-master/add-product-master.component';
import { ModifyProductMasterComponent } from './components/product-master-controller/modify-product-master/modify-product-master.component';
import { DeleteProductMasterComponent } from './components/product-master-controller/delete-product-master/delete-product-master.component';
import { ProductMasterListComponent } from './components/product-master-controller/product-master-list/product-master-list.component';
import { AllTaskStatusWiseComponent } from './components/task-management/all-task-status-wise/all-task-status-wise.component';
import { AddPredefinedParameterComponent } from './components/master-data-management/predefined-parameter-controller/add-predefined-parameter/add-predefined-parameter.component';
import { PredefinedParameterListComponent } from './components/master-data-management/predefined-parameter-controller/predefined-parameter-list/predefined-parameter-list.component';
import { UpdatePredefinedParameterComponent } from './components/master-data-management/predefined-parameter-controller/update-predefined-parameter/update-predefined-parameter.component';
import { DeletePredefinedParameterComponent } from './components/master-data-management/predefined-parameter-controller/delete-predefined-parameter/delete-predefined-parameter.component';
import { ProductMasterGroupListComponent } from './components/master-data-management/product-master-group-controller/product-master-group-list/product-master-group-list.component';
import { AddProductMasterGroupComponent } from './components/master-data-management/product-master-group-controller/add-product-master-group/add-product-master-group.component';
import { DeleteProductMasterGroupComponent } from './components/master-data-management/product-master-group-controller/delete-product-master-group/delete-product-master-group.component';
import { ModifyProductMasterGroupComponent } from './components/master-data-management/product-master-group-controller/modify-product-master-group/modify-product-master-group.component';
import { LatestProductStockInfoComponent } from './components/inventery-management/latest-product-stock-info/latest-product-stock-info.component';
import { VendorListComponent } from './components/inventery-management/vendor-master-controller/vendor-list/vendor-list.component';
import { AddVendorComponent } from './components/inventery-management/vendor-master-controller/add-vendor/add-vendor.component';
import { ModifyVendorComponent } from './components/inventery-management/vendor-master-controller/modify-vendor/modify-vendor.component';
import { VendorRequestsComponent } from './components/inventery-management/vendor-master-controller/vendor-requests/vendor-requests.component';
import { VendorApprovedComponent } from './components/inventery-management/vendor-master-controller/vendor-approved/vendor-approved.component';
import { VendorBlockedComponent } from './components/inventery-management/vendor-master-controller/vendor-blocked/vendor-blocked.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ExistingCustomerListComponent } from './components/existing-customer-module/existing-customer-list/existing-customer-list.component';
import { TobeApprovedListComponent } from './components/existing-customer-module/tobe-approved-list/tobe-approved-list.component';
import { EcMapComponent } from './components/existing-customer-module/ec-map/ec-map.component';
import { PopupDetailsComponent } from './components/existing-customer-module/popup-details/popup-details.component';
import { EcFilterComponent } from './components/existing-customer-module/ec-filter/ec-filter.component';
import { TobeVerifiedListComponent } from './components/existing-customer-module/tobe-verified-list/tobe-verified-list.component';
import { TaskCountTechnicianComponent } from './components/task-management/task-count-technician/task-count-technician.component';
import { UpdateTicketPriorityTimeComponent } from './components/ticket-management/update-ticket-priority-time/update-ticket-priority-time.component';
import { MaterialToBeIssuedComponent } from './components/inventery-management/material-to-be-issued/material-to-be-issued.component';
import { MaterialIssuedListComponent } from './components/inventery-management/material-issued-list/material-issued-list.component';
import { UpdateTaskPriorityTimeComponent } from './components/task-management/update-task-priority-time/update-task-priority-time.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ClientDocComponent } from './components/client-doc/client-doc.component';
import { TreeModule } from 'primeng/tree';
import { ImageModule } from 'primeng/image';
import { GeoFenceComponent } from './components/inventery-management/branch-master-management/geo-fence/geo-fence.component';
import { LayerObjectComponent } from './components/inventery-management/branch-master-management/layer-object/layer-object.component';
import { BranchMapComponent } from './components/inventery-management/branch-master-management/branch-map/branch-map.component';
import { UserLatestLocationComponent } from './components/employee-module/user-latest-location/user-latest-location.component';
import { MapPopupComponent } from './components/employee-module/map-popup/map-popup.component';
import { CustomerProductPriceListComponent } from './components/master-data-management/customer-product-price-controller/customer-product-price-list/customer-product-price-list.component';
import { AddCustomerProductPriceComponent } from './components/master-data-management/customer-product-price-controller/add-customer-product-price/add-customer-product-price.component';
import { DeleteCustomerProductPriceComponent } from './components/master-data-management/customer-product-price-controller/delete-customer-product-price/delete-customer-product-price.component';
import { ModifyCustomerProductPriceComponent } from './components/master-data-management/customer-product-price-controller/modify-customer-product-price/modify-customer-product-price.component';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ReportComponent } from './components/user-management/report/report.component';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { ObjectGroupListComponent } from './components/master-data-management/object-group-master-controller/object-group-list/object-group-list.component';
import { DeleteObjectGroupComponent } from './components/master-data-management/object-group-master-controller/delete-object-group/delete-object-group.component';
import { ModifyObjectGroupComponent } from './components/master-data-management/object-group-master-controller/modify-object-group/modify-object-group.component';
import { ObjectTypeListComponent } from './components/master-data-management/object-type-master-controller/object-type-list/object-type-list.component';
import { DeleteObjectTypeComponent } from './components/master-data-management/object-type-master-controller/delete-object-type/delete-object-type.component';
import { ModifyObjectTypeComponent } from './components/master-data-management/object-type-master-controller/modify-object-type/modify-object-type.component';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SplitterModule } from 'primeng/splitter';
import { SubMenuComponent } from './components/client-doc/sub-menu/sub-menu.component';
import { MenuComponent } from './components/client-doc/menu/menu.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccessPrivilegesRequestsComponent } from './components/client-doc/access-privileges-requests/access-privileges-requests.component';
import { LayerPopupComponent } from './components/inventery-management/branch-master-management/layer-popup/layer-popup.component';
import { InputTextModule } from 'primeng/inputtext';
import { ChartModule } from 'primeng/chart';
import { PaymentTermListComponent } from './components/payment-term-controller/payment-term-list/payment-term-list.component';
import { AddPaymentTermComponent } from './components/payment-term-controller/add-payment-term/add-payment-term.component';
import { ModifyPaymentTermComponent } from './components/payment-term-controller/modify-payment-term/modify-payment-term.component';
import { DeletePaymentTermComponent } from './components/payment-term-controller/delete-payment-term/delete-payment-term.component';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';


import { PaginatorModule } from 'primeng/paginator';
import { DividerModule } from 'primeng/divider';
import { SliderModule } from 'primeng/slider';
import { AddLocationComponent } from './components/master-data-management/location-controller/add-location/add-location.component';
import { DeleteLocationComponent } from './components/master-data-management/location-controller/delete-location/delete-location.component';
import { LocationListComponent } from './components/master-data-management/location-controller/location-list/location-list.component';
import { ModifyLocationComponent } from './components/master-data-management/location-controller/modify-location/modify-location.component';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
import { ClientDocsFilterComponent } from './components/client-doc/client-docs-filter/client-docs-filter.component';

import { AssetListComponent } from './components/master-data-management/asset-list/asset-list.component';
import { AssetListFilterComponent } from './components/master-data-management/asset-list-filter/asset-list-filter.component';
import { ObjectAllocationRegisterComponent } from './components/master-data-management/object-allocation-register/object-allocation-register.component';
import { MaintenanceScheduleComponent } from './components/master-data-management/maintenance-schedule/maintenance-schedule.component';
import { RepairInfoComponent } from './components/master-data-management/repair-info/repair-info.component';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEnIN from '@angular/common/locales/en-IN';
import localeFr from '@angular/common/locales/fr';
import localeJa from '@angular/common/locales/ja';
import localeEnGB from '@angular/common/locales/en-GB';
import { HelpComponent } from './components/help/help.component';
import { PerformanceHistoryComponent } from './components/master-data-management/performance-history/performance-history.component';
import { UomComponent } from './components/uom/uom.component';
import { TicketPriorityDefinitionComponent } from './components/ticket-management/ticket-priority-definition/ticket-priority-definition.component';
import { TaskPriorityDefinitionComponent } from './components/task-management/task-priority-definition/task-priority-definition.component';
import { TicketTaskPriorityDefinitionComponent } from './components/ticket-task-priority-definition/ticket-task-priority-definition.component';
import { TaxMasterListComponent } from './components/tax-master-controller/tax-master-list/tax-master-list.component';
import { RouteAccessGuard } from './guards/route-access.guard';
import { ObjectCategoryControllerComponent } from './components/object-category-controller/object-category-controller.component';
import { DepreciationRegisterControllerComponent } from './components/depreciation-register-controller/depreciation-register-controller.component';
import { ApprovalComponent } from './components/Prospect-Management/approval/approval.component';
import { ProspectInfoComponent } from './components/Prospect-Management/prospect-info/prospect-info.component';
import { VerificationComponent } from './components/Prospect-Management/verification/verification.component';
import { AssetDeprciationMethodControllerComponent } from './components/asset-deprciation-method-controller/asset-deprciation-method-controller.component';
import { DepartmentInfoControllerComponent } from './components/master-data-management/department-info-controller/department-info-controller.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AssettoTicketComponent } from './components/ticket-management/assetto-ticket/assetto-ticket.component';
import { AssettoTaskComponent } from './components/task-management/assetto-task/assetto-task.component';
import { PageSoonComponent } from './page-soon/page-soon.component';
import { AssetLiveMonitoringComponent } from './components/master-data-management/asset-live-monitoring/asset-live-monitoring.component';
import { AssetDataRegisterComponent } from './components/master-data-management/asset-data-register/asset-data-register.component';
import { AssetBuldComponent } from './components/master-data-management/asset-buld/asset-buld.component';
import { AssetAuditInfoComponent } from './components/asset-audit-info/asset-audit-info.component';
import { AssetAuditReportComponent } from './components/asset-audit-report/asset-audit-report.component';
import { AssetPerformanceComponent } from './components/master-data-management/asset-performance/asset-performance.component';
import { AssetBudgetingComponent } from './components/asset-budgeting/asset-budgeting.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StatusInfoControllerComponent } from './components/master-data-management/status-info-controller/status-info-controller.component';
import { AssetReportComponent } from './components/master-data-management/asset-report/asset-report.component';
import { InventoryReportComponent } from './components/master-data-management/inventory-report/inventory-report.component';
import { EcComponent } from './components/existing-customer-module/ec/ec.component';
import { ChartComponent } from './components/chart/chart.component';
import { ObjectAllocationRegisterHistoryComponent } from './components/master-data-management/object-allocation-register-history/object-allocation-register-history.component';
import { IDealerListComponent } from './components/i-dealer-controller/i-dealer-list/i-dealer-list.component';
import { DealerLocateDeviceComponent } from './components/network-visibility/dealer-locate-device/dealer-locate-device.component';
import { DealerFilterComponent } from './components/i-dealer-controller/dealer-filter/dealer-filter.component';
import { TelcoCustomerControllerComponent } from './components/telco-customer-controller/telco-customer-controller.component';
import { PrintComponent } from './print/print.component';
import { TelcoMapComponent } from './components/telco-map/telco-map.component';
import { SafeUrlPipe } from './safe-url.pipe';
import { ChartsComponent } from './components/charts/charts.component';
import { AssetComponent } from './components/master-data-management/asset/asset.component';
import { DashBoard1Component } from './components/dash-board1/dash-board1.component';
import { AssetHoldingComponent } from './components/master-data-management/asset-holding/asset-holding.component';
import { TemplateCountsComponent } from './components/master-data-management/template-counts/template-counts.component';
import { LiveComponent } from './live/live.component';
import { ObjectAllocationRegisterGroupComponent } from './components/master-data-management/object-allocation-register-group/object-allocation-register-group.component';
import { AssetCompareComponent } from './components/master-data-management/asset-compare/asset-compare.component';
import { WsService } from './services/ws.service';
import { CustomerInfoComponent } from './components/customer-info/customer-info.component';
import { CustomerLocationInfoComponent } from './components/customer-location-info/customer-location-info.component';
import { FacesRegisterComponent } from './components/master-data-management/faces-register/faces-register.component';
import { ServiceProvidersControllerComponent } from './components/service-providers-controller/service-providers-controller.component';
import { CompositionComponent } from './components/composition/composition.component';
import { BatchInfoListComponent } from './components/batchInfo/batch-info-list/batch-info-list.component';
import { ObjectTransitControllerComponent } from './components/object-transit-controller/object-transit-controller.component';
import { RolesControllerComponent } from './components/user-management/roles-controller/roles-controller.component';
import { UploadBulkAssetMapComponent } from './components/master-data-management/upload-bulk-asset-map/upload-bulk-asset-map.component';
import { DefineServiceComponent } from './components/service-definition-controller/define-service/define-service.component';
import { Msg91Component } from './msg91/msg91.component';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { PrivilegesGenerateComponent } from './components/user-management/privileges-generate/privileges-generate.component';
import { RolesGenerateComponent } from './components/user-management/roles-generate/roles-generate.component';
import { BusinessOwnerComponent } from './components/user-management/business-owner/business-owner.component';
import { ClientConfigListComponent } from './components/client-config/client-config-list/client-config-list.component';
import { CompanyInfoControllerComponent } from './components/company-info-controller/company-info-controller.component';
import { UserTypeComponent } from './components/user-type/user-type.component';
import { AssetStockPointComponent } from './components/master-data-management/asset-stock-point/asset-stock-point.component';

import { EditorWorkflowComponent } from './components/TvProductionTracker/Editor/editor-workflow/editor-workflow.component';
import { TitleWorkflowComponent } from './components/TvProductionTracker/Title/title-workflow/title-workflow.component';
import { GraphicsWorkflowComponent } from './components/TvProductionTracker/Graphics/graphics-workflow/graphics-workflow.component';
import { SeoWorkflowComponent } from './components/TvProductionTracker/SEO/seo-workflow/seo-workflow.component';
import { EpisodeWorkflowComponent } from './components/TvProductionTracker/Episode/episode-workflow/episode-workflow.component';
import { QualityCheckWorkflowComponent } from './components/TvProductionTracker/QualityCheck/quality-check-workflow/quality-check-workflow.component';
import { PublishingWorkflowComponent } from './components/TvProductionTracker/Publishing/publishing-workflow/publishing-workflow.component';
import { TvProductionTrackerFilterComponent } from './components/TvProductionTracker/tv-production-tracker-filter/tv-production-tracker-filter.component';
import { TvProductionTrackerCalendarComponent } from './components/TvProductionTracker/tv-production-tracker-calendar/tv-production-tracker-calendar.component';
import { AssettoGptComponent } from './components/assetto-gpt/assetto-gpt.component';
import { AppPropertiesConfigListComponent } from './components/master-data-management/app-properties-config-controller/app-properties-config-list/app-properties-config-list.component';
import { TicketPriorityDefinitionControllerComponent } from './components/master-data-management/ticket-priority-definition-controller/ticket-priority-definition-controller.component';
import { UserLiveTrackingComponent } from './components/user-management/user-live-tracking/user-live-tracking.component';
import { TicketBySourceComponent } from './components/ticket-management/ticket-by-source/ticket-by-source.component';
import { PcrWorkflowComponent } from './components/TvProductionTracker/Pcr/pcr-workflow/pcr-workflow.component';
import { CameramanWorkflowComponent } from './components/TvProductionTracker/Cameraman/cameraman-workflow/cameraman-workflow.component';


registerLocaleData(localeEnIN);
registerLocaleData(localeFr);
registerLocaleData(localeJa);
registerLocaleData(localeEnGB);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DashBoardComponent,
    DashBoard1Component,
    HeaderComponent,
    FooterComponent,
    LoginPageComponent,
    UsersListComponent,
    CreateUserComponent,
    ProductMasterManagementComponent,
    BranchMasterManagementComponent,
    VendorMasterManagementComponent,
    TaskListComponent,
    AddTaskComponent,
    TaskCommComponent,
    ModifyTaskComponent,
    DeleteTaskComponent,
    TicketsListComponent,
    AddTicketComponent,
    TicketCommComponent,
    ModifyTicketComponent,
    DeleteTicketComponent,
    MaterialIssuesComponent,
    MaterialTransferComponent,
    TicketTypesComponent,
    MaterialPurchaseComponent,
    MaterialIssueRequestsComponent,
    ProductStockManagementComponent,
    NotificationManagementComponent,
    DefineParamsComponent,
    TaskMasterComponent,
    ParamsListComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    ParamsUpdateComponent,
    ObjectTemplateComponent,
    ProductOpeningBalanceComponent,
    RolesComponent,
    TaskFilterComponent,
    CustomerParamsComponent,
    PrivilegesListComponent,
    MyTasksComponent,
    TicketFilterComponent,
    TaskPostedByMeComponent,
    TicketPostedByMeComponent,
    DeleteRoleComponent,
    DeleteProductComponent,
    DeleteVendorComponent,
    DeleteBranchComponent,
    DeleteIssueComponent,
    DeletePurchaseComponent,
    DeleteTransferComponent,
    DeleteUserComponent,
    DeletePrivilegeComponent,
    TicketSubTypeComponent,
    DeleteTicketTypeComponent,
    DeleteTicketSubTypeComponent,
    DeleteParamComponent,
    DeleteCustomerParamComponent,
    ProdcutCompositionComponent,
    UpdateProductComponent,
    UpdateBranchComponent,
    UpdateVendorComponent,
    ModifyTicketTypeComponent,
    ModifyTicketSubTypeComponent,
    ModifyCustomerParamComponent,
    ModifyParamComponent,
    ModifyCustomerInfoComponent,
    ModifyCompanyNewsComponent,
    ModifyUserComponent,
    ModifyRoleComponent,
    ModifyPrivilegeComponent,
    ObjectDeleteComponent,
    ObjectModifyComponent,
    ProdcutModifyComponent,
    ProdcutDeleteComponent,
    UserTaskComponent,
    UserTicketComponent,
    PendingApprovalComponent,
    RouteManagementComponent,
    RouteModifyComponent,
    RouteDeleteComponent,
    RouteMapComponent,
    LocateDeviceComponent,
    OfferListComponent,
    OfferDeleteComponent,
    OfferModifyComponent,
    OfferAddComponent,
    EmployeeAttendenceComponent,
    TaskTrackingComponent,
    UserTrackingComponent,
    ServiceDefinitionComponent,
    CustomerAPKVersionComponent,
    DeleteCustomerAPKComponent,
    ModifyCustomerAPKComponent,
    DeleteServiceDefinitionComponent,
    ModifyServiceDefinitionComponent,
    SearchTicketsComponent,
    MarketingDataComponent,
    StatusInfoComponent,
    ObjectTypeGroupComponent,
    MarketingDataFilterComponent,
    MarketingDataByUserComponent,
    ProfileComponent,
    PopupComponent,
    CProductListComponent,
    ProductCompositionComponent,
    ProductCompositionListComponent,
    AddMaterialChargeComponent,
    MaterialChargeListComponent,
    ProductDisplayZoneListComponent,
    AddProductDisplayZoneComponent,
    ModifyProductDisplayZoneComponent,
    DeleteProductDisplayZoneComponent,
    ProductCategoryListComponent,
    AddProductCategoryComponent,
    ModifyProductCategoryComponent,
    DeleteProductCategoryComponent,
    ProductCompositionDeleteComponent,
    ProductCompositionModifyComponent,
    AddProductMasterComponent,
    ModifyProductMasterComponent,
    DeleteProductMasterComponent,
    ProductMasterListComponent,
    AllTaskStatusWiseComponent,
    AddPredefinedParameterComponent,
    PredefinedParameterListComponent,
    UpdatePredefinedParameterComponent,
    DeletePredefinedParameterComponent,
    ProductMasterGroupListComponent,
    AddProductMasterGroupComponent,
    DeleteProductMasterGroupComponent,
    ModifyProductMasterGroupComponent,
    LatestProductStockInfoComponent,
    VendorListComponent,
    AddVendorComponent,
    ModifyVendorComponent,
    VendorRequestsComponent,
    VendorApprovedComponent,
    VendorBlockedComponent,
    ExistingCustomerListComponent,
    TobeApprovedListComponent,
    EcMapComponent,
    PopupDetailsComponent,
    EcFilterComponent,
    TobeVerifiedListComponent,
    TaskCountTechnicianComponent,
    UpdateTicketPriorityTimeComponent,
    MaterialToBeIssuedComponent,
    MaterialIssuedListComponent,
    UpdateTaskPriorityTimeComponent,
    ClientDocComponent,
    GeoFenceComponent,
    LayerObjectComponent,
    BranchMapComponent,
    UserLatestLocationComponent,
    MapPopupComponent,
    CustomerProductPriceListComponent,
    AddCustomerProductPriceComponent,
    DeleteCustomerProductPriceComponent,
    ModifyCustomerProductPriceComponent,
    ReportComponent,
    ObjectGroupListComponent,
    DeleteObjectGroupComponent,
    ModifyObjectGroupComponent,
    ObjectTypeListComponent,
    DeleteObjectTypeComponent,
    ModifyObjectTypeComponent,
    SubMenuComponent,
    MenuComponent,
    AccessPrivilegesRequestsComponent,
    LayerPopupComponent,
    PaymentTermListComponent,
    AddPaymentTermComponent,
    ModifyPaymentTermComponent,
    DeletePaymentTermComponent,
    AddLocationComponent,
    DeleteLocationComponent,
    LocationListComponent,
    ModifyLocationComponent,
    ClientDocsFilterComponent,
    UomComponent,
    TicketPriorityDefinitionComponent,
    TaskPriorityDefinitionComponent,
    TicketTaskPriorityDefinitionComponent,
    TaxMasterListComponent,
    AssetListComponent,
    AssetListFilterComponent,
    ObjectAllocationRegisterComponent,
    MaintenanceScheduleComponent,
    RepairInfoComponent,
    HelpComponent,
    DefineServiceComponent,
    PerformanceHistoryComponent,
    ObjectCategoryControllerComponent,
    DepreciationRegisterControllerComponent,
    ApprovalComponent,
    ProspectInfoComponent,
    VerificationComponent,
    AssetDeprciationMethodControllerComponent,
    DepartmentInfoControllerComponent,
    BreadcrumbComponent,
    PageNotFoundComponent,
    AssettoTicketComponent,
    AssettoTaskComponent,
    PageSoonComponent,
    AssetLiveMonitoringComponent,
    AssetDataRegisterComponent,
    AssetBuldComponent,
    AssetAuditInfoComponent,
    AssetAuditReportComponent,
    AssetPerformanceComponent,
    AssetBudgetingComponent,
    StatusInfoControllerComponent,
    AssetReportComponent,
    InventoryReportComponent,
    EcComponent,
    ChartComponent,
    ObjectAllocationRegisterHistoryComponent,
    IDealerListComponent,
    DealerLocateDeviceComponent,
    DealerFilterComponent,
    TelcoCustomerControllerComponent,
    PrintComponent,
    TelcoMapComponent,
    SafeUrlPipe,
    ChartsComponent,
    AssetComponent,
    AssetHoldingComponent,
    TemplateCountsComponent,
    LiveComponent,
    ObjectAllocationRegisterGroupComponent,
    AssetCompareComponent,
    CustomerInfoComponent,
    CustomerLocationInfoComponent,
    FacesRegisterComponent,
    ServiceProvidersControllerComponent,
    CompositionComponent,
    BatchInfoListComponent,
    ObjectTransitControllerComponent,
    RolesControllerComponent,
    UploadBulkAssetMapComponent,
    Msg91Component,
    PrivilegesGenerateComponent,
    RolesGenerateComponent,
    BusinessOwnerComponent,
    ClientConfigListComponent,
    CompanyInfoControllerComponent,
    UserTypeComponent,
    AssetStockPointComponent,

    EditorWorkflowComponent,
    TitleWorkflowComponent,
    GraphicsWorkflowComponent,
    SeoWorkflowComponent,
    EpisodeWorkflowComponent,
    QualityCheckWorkflowComponent,
    PublishingWorkflowComponent,
    TvProductionTrackerFilterComponent,
    TvProductionTrackerCalendarComponent,
    AssettoGptComponent,
    AppPropertiesConfigListComponent,
    TicketPriorityDefinitionControllerComponent,
    UserLiveTrackingComponent,
    TicketBySourceComponent,
    PcrWorkflowComponent,
    CameramanWorkflowComponent
  ],

  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatRadioModule,
    DragDropModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    Ng2SearchPipeModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPaginationModule,
    PdfViewerModule,
    TimelineModule,
    CardModule,
    OnlineStatusModule,
    QRCodeModule,
    CKEditorModule,
    NgxSkeletonLoaderModule,
    TreeModule,
    ContextMenuModule,
    AccordionModule,
    ImageModule,
    DropdownModule,
    MultiSelectModule,
    OrganizationChartModule,
    SplitterModule,
    ToastModule,
    MessagesModule,
    ProgressSpinnerModule,
    InputTextModule,
    TooltipModule,
    ChartModule,
    MenuModule,
    ButtonModule,
    PaginatorModule, DividerModule, SliderModule,
    BadgeModule,
    BreadcrumbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    AuthGuard, RouteAccessGuard,
    WebsocketService,
    WsService,
    MessageService,
    ChatService,
    { provide: LOCALE_ID, useValue: 'en-US' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }